import React from "react";
import { Modal } from "../Modal";
import axios from "axios";
import { connect } from "react-redux";
import { Button } from "../Button";
import { getStorage } from "../../utils/storage";
import api from "../../utils/api";

class AlertMessage extends React.Component {
  state = {
    showAlertMessageModal: false,
  };

  handleOpenModal(modal) {
    this.setState({ [modal]: true });
  }

  handleCloseModal(modal) {
    this.setState({ [modal]: false });
  }

  componentDidMount() {
    this.getProfileUnits();
  }

  getProfileUnits = async () => {
    const user = await getStorage();

    let headers = {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${user.accessToken}`,
    };

    const options = {
      method: "GET",
      url: `${api("profile")}/profile/units`,
      data: null,
      headers,
    };

    return await axios(options)
      .then((data) => {
        let countApproved = 0,
          countProvided = 0;
        data.data.forEach((el) => {
          if (el.provided) {
            countProvided += 1;
          }

          if (el.approved) {
            countApproved += 1;
          }
        });

        console.log({
          data: data.data.length,
          countApproved,
          countProvided,
        });

        if (
          data.data.length === countApproved &&
          data.data.length === countProvided
        ) {
          this.setState({
            title: "All is Set!",
            description:
              "Your account has been approved, you can now navigate to the dashboard",
            actionButton: "Dashboard",
            handleActionButtonPressed: () =>
              this.handleActionButtonPressed("/merchant/analytics"),
            showAlertMessageModal: true,
          });

          return;
        }

        if (data.data.length === countProvided) {
          this.setState({
            title: "Your Account is under review",
            description: "We will notify you of your account being reviewed",
            showAlertMessageModal: true,
          });
        }
      })
      .catch((error) => {
        console.log("Error occur while fetching business units: ", error);
      });
  };

  handleActionButtonPressed(link) {
    window.location.href = link;
  }

  render() {
    return (
      <div>
        <Modal
          handleClose={this.handleCloseModal.bind(
            this,
            "showAlertMessageModal"
          )}
          show={this.state.showAlertMessageModal}
        >
          <div>
            <div className="card-body">
              <div>
                <h2>{this.state.title}</h2>
                <p>{this.state.description}</p>
              </div>
            </div>
            {this.state.actionButton && (
              <div className="modal-footer">
                <Button
                  text={this.state.actionButton}
                  onPress={this.state.handleActionButtonPressed}
                />
              </div>
            )}
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(AlertMessage);
